"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Percent = exports.Notation = void 0;
exports.Notation = {
    STANDARD: "standard",
    COMPACT: "compact",
};
exports.Percent = {
    STANDARD: "standard",
    DECIMAL: "decimal",
};
//# sourceMappingURL=Number.types.js.map